export var SR_FORMAT = {
  LATLONG: 'LATLONG',
  MANAGEDPLACEID: 'MANAGEDPLACEID',
  PLACEID: 'PLACEID',
  EN_DIST: '40',
  DIST: '50'
};
export var PROMO_CODE_COOKIE = 'activePromotionCode';
export var SESSION_STORAGE_PROMO_COOKIE_SET = 'promoCodeCookieSet';
export var PROMO_CODE_LANDING_PAGE_COOKIE = 'landingPagePromoCodeCookie';
export var PROMO_CODE_LANDING_PAGE_SESSION = 'landingPagePromoCode';